enum ETreeGroupTypes {
  None = '',
  Type = 'type',
  Name = 'name',
  DateCreated = 'date created',
  Owner = 'owner',
}

export default ETreeGroupTypes;
